import classNames from "classnames";
import {
  Bookmark,
  Boxes,
  ChartColumn,
  ChartSpline,
  FileText,
  Folder,
  HardDrive,
  LayoutDashboard,
  Library,
  Route,
  Map as MapIcon,
  PanelTop,
  Square,
  SquareMousePointer,
  Table2,
} from "lucide-react";

import { type ContextType } from "../contextType";

/**
 * What a context chip can show an icon for: every context type, plus items
 * that sit in a type's group but take a glyph of their own:
 * - the View loaded on a table, shown with the View picker's bookmark so the
 *   chip reads as a View;
 * - a section, or a panel of each kind, selected on a board's canvas.
 */
export type ContextIconKind =
  | ContextType
  | "view"
  | "board_section"
  | "chart_panel"
  | "table_panel"
  | "map_panel"
  | "panel";

interface ContextIconProps {
  contextType: ContextIconKind;
  className?: classNames.Argument;
}

/**
 * Context icon component for a given context type.
 */
export function ContextIcon(props: ContextIconProps) {
  const { contextType, className } = props;

  switch (contextType) {
    case "dataset":
      return <Folder className={classNames(className)} />;
    case "file":
      return <FileText className={classNames(className)} />;
    case "collection":
      return <Library className={classNames(className)} />;
    case "device":
      return <HardDrive className={classNames(className)} />;
    case "deviceType":
      return <Boxes className={classNames(className)} />;
    case "session":
      return <Route className={classNames(className)} />;
    case "table":
      return <Table2 className={classNames(className)} />;
    case "view":
      return <Bookmark className={classNames(className)} />;
    case "viz_state":
      return <ChartSpline className={classNames(className)} />;
    case "board":
      return <LayoutDashboard className={classNames(className)} />;
    case "selected_on_canvas":
      return <SquareMousePointer className={classNames(className)} />;
    case "board_section":
      return <PanelTop className={classNames(className)} />;
    case "chart_panel":
      return <ChartColumn className={classNames(className)} />;
    case "table_panel":
      return <Table2 className={classNames(className)} />;
    case "map_panel":
      return <MapIcon className={classNames(className)} />;
    case "panel":
      return <Square className={classNames(className)} />;
  }
}
